module.exports = __webpack_public_path__ + "media/theme/icon__response-40bc2997.png";